module.exports = __webpack_public_path__ + "vk.png?b838093c7c6961ff9ab884b2a2bb3b33";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SocialNetworks/vk.png
// module id = 75
// module chunks = 0